module.exports = __webpack_public_path__ + "img/77-78-plan.01fa57df.jpg";